import { View } from 'react-native';
import { Screen } from '@/components/layout/Screen';
import { Body, SubHeading } from '@/components/ui/Text';
import { useTheme } from '@/theme';

export default function SupportScreen() {
  const theme = useTheme();

  return (
    <Screen title="Support" subtitle="We usually respond within 24–48 hours.">
      <View style={{ gap: theme.spacing(2) }}>
        <SubHeading>Contact</SubHeading>
        <Body color={theme.colors.textSecondary}>
          Email us at support@yourdomain.com (replace this with your real support email before submitting to the
          stores).
        </Body>
      </View>
    </Screen>
  );
}


